import { SET_IMAGE, HIDE_MESSAGE } from '../actions/actionTypes';

const initialState = {
    images: {}
}
function ImageReducers(state = initialState, action) {
    switch (action.type) {
        case SET_IMAGE:
            return {
                ...state,
                images: {
                    ...state.images, ...action.payload
                }
            }
        case HIDE_MESSAGE:
            return initialState;
        default: return state;
    }
}
export default ImageReducers;